$(document).ready(function () {

  var $slider = $(".mcs__products");
  if (!$slider.length) return;

  var totalProducts = $slider.find(".mcs-product").length;
  var DESKTOP_BP = 750;
  var DESKTOP_SHOW = 3;

  // ===== SLIDER RESPONSIVO =====
  // Mobile: slider si hay 2+ productos.
  // Desktop: slider solo si hay más de 3; con 1-3 se muestran centrados sin slider.
  function needsSlider() {
    var isDesktop = window.matchMedia("(min-width: " + DESKTOP_BP + "px)").matches;
    if (isDesktop) return totalProducts > DESKTOP_SHOW;
    return totalProducts > 1;
  }

  function initSlider() {
    if ($slider.hasClass("slick-initialized")) return;

    $slider.slick({
      dots: true,
      arrows: true,
      infinite: true,
      autoplay: false,
      slidesToShow: DESKTOP_SHOW,
      slidesToScroll: 1,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: DESKTOP_BP,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        }
      ]
    });
  }

  function destroySlider() {
    if ($slider.hasClass("slick-initialized")) {
      $slider.slick("unslick");
    }
  }

  function syncSlider() {
    if (needsSlider()) {
      initSlider();
    } else {
      destroySlider();
    }
  }

  syncSlider();

  var resizeTimer;
  $(window).on("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncSlider, 200);
  });

  // El modal arranca oculto: Slick necesita recalcular al abrirse.
  $(window).on("mcs:modal-opened", function () {
    if ($slider.hasClass("slick-initialized")) {
      $slider.slick("setPosition");
    }
  });

  // ===== IMAGEN / PRECIO SEGÚN VARIANTE =====
  function updateCard($card) {
    var $option = $card.find(".mcs-product__variant-select option:selected");

    $card.find(".mcs-product__price").text($option.data("price"));

    var comparePrice = $option.data("compare-price");
    var $compare = $card.find(".mcs-product__compare-price");
    if (comparePrice && comparePrice !== "") {
      $compare.text(comparePrice).removeClass("is-hidden");
    } else {
      $compare.text("").addClass("is-hidden");
    }

    var image = $option.data("image");
    if (image && image !== "") {
      $card.find(".mcs-product__main-image").attr("src", image);
    }
  }

  $(".mcs-product").each(function () {
    updateCard($(this));
  });

  $(document).on("change", ".mcs-product__variant-select", function () {
    updateCard($(this).closest(".mcs-product"));
  });

  // ===== ADD TO CART =====
  $(document).on("click", ".mcs-product__add", function () {
    var $button = $(this);
    var $card = $button.closest(".mcs-product");
    var variantId = $card.find(".mcs-product__variant-select").val();

    if (!variantId || $button.prop("disabled")) return;

    $button.prop("disabled", true).text("Adding...");

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { items: [{ id: variantId, quantity: 1 }] },
      dataType: "json"
    })
      .done(function () {
        $button.addClass("is-added").text("Added!");

        // Refresca la barra de recompensas (por si Rebuy no emite el evento
        // para adds hechos fuera de su widget).
        $.getJSON("/cart.js", function (cart) {
          if (window.updateRewardsProgress) {
            window.updateRewardsProgress(cart.total_price);
          }
          document.dispatchEvent(
            new CustomEvent("mcs:cart.updated", { detail: { cart: cart } })
          );
        });

        setTimeout(function () {
          $button.removeClass("is-added").prop("disabled", false).text("Add To Cart");
        }, 1500);
      })
      .fail(function () {
        console.log("Error al agregar el producto al carrito");
        $button.prop("disabled", false).text("Add To Cart");
      });
  });

});